import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { PrescriptionFormInputProvider } from '../../context/PrescriptionFormInputContext.js';
import { PrescriptionFormInputLabel } from '../PrescriptionFormInputLabel/PrescriptionFormInputLabel.js';
import { PrescriptionFormInputSelect } from '../PrescriptionFormInputSelect/PrescriptionFormInputSelect.js';

const PrescriptionFormInput = /*#__PURE__*/ React.memo((props)=>{
    const { side , hideLabels  } = props;
    return /*#__PURE__*/ React.createElement(PrescriptionFormInputProvider, swcHelpers.extends({}, props), /*#__PURE__*/ React.createElement(PrescriptionFormInputLabel, {
        side: side,
        isHiddenVisually: hideLabels
    }), /*#__PURE__*/ React.createElement(PrescriptionFormInputSelect, null));
});

export { PrescriptionFormInput };
//# sourceMappingURL=PrescriptionFormInput.js.map
